import type { CadFile } from '@cutr/constants/order';

const ANALYSIS_DONE = ['complete', 'failed'];
const SVF_DONE = ['available', 'failed'];
const EXTRACTION_RUNNING = ['pending', 'processing'];

export function isAnalysingModel(
  file?: Partial<Pick<CadFile, 'type' | 'analysisStatus'>>
) {
  return (
    file?.type === '3D' && !ANALYSIS_DONE.includes(String(file.analysisStatus))
  );
}

export function isExtractingText(file?: CadFile) {
  return EXTRACTION_RUNNING.includes(String(file?.extractedTextStatus));
}

export function isAnalysing(file?: CadFile) {
  return isAnalysingModel(file) || isExtractingText(file);
}

export function isProcessingSvf(file?: Pick<CadFile, 'svf'>) {
  return Boolean(file?.svf) && !SVF_DONE.includes(String(file?.svf));
}

export function isGeneratingSvg(file?: CadFile) {
  return file?.filetype === 'dxf' && !file.generatedSvgURI;
}

export function isRunning(file: CadFile) {
  return isAnalysing(file) || isProcessingSvf(file) || isGeneratingSvg(file);
}

export function asTimedOut(file: CadFile): CadFile {
  return {
    ...file,
    analysisStatus: isAnalysingModel(file) ? 'failed' : file.analysisStatus,
    extractedTextStatus: isExtractingText(file)
      ? 'failed'
      : file.extractedTextStatus,
    svf: isProcessingSvf(file) ? 'failed' : file.svf,
  };
}
